<template>
  <path
    d="M20 6.00024H12L10.59 4.59024C10.21 4.21024 9.7 4.00024 9.17 4.00024H4C2.9 4.00024 2.01 4.90024 2.01 6.00024L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V8.00024C22 6.90024 21.1 6.00024 20 6.00024ZM19 18.0002H5C4.45 18.0002 4 17.5502 4 17.0002V9.00024C4 8.45024 4.45 8.00024 5 8.00024H19C19.55 8.00024 20 8.45024 20 9.00024V17.0002C20 17.5502 19.55 18.0002 19 18.0002Z"
  />
</template>
